module.exports = __webpack_public_path__ + "static/media/edge.20081866.png";